<div class="mt-8 mb-4">

    <div class="flex justify-between items-center w-full mb-4">

        <div class="flex flex-row justify-between">
            <app-btn-back></app-btn-back>
        </div>

    </div>

    <div class="flex flex-col gap-2 mb-4 border-0 w-full">

        <h1 class="font-semibold text-2xl text-primary-500">
            Question Bank
        </h1>
        <span class="text-sm text-gray-500">
            Search, view, and manage your question bank. Use one or more filters below to find specific questions or
            explore by Bible reference and tags.
        </span>

        <app-question-search 
            [groupId]="groupId" 
            (searchResults)="onSearchResults($event)" 
            (searchCleared)="onSearchCleared()">
        </app-question-search>

        @let questions = questions$ | async;

        <span class="text-sm font-semibold text-gray-500 mb-2">{{ questions?.length ?? 0 }} question(s) found</span>

        @for (q of questions; track $index) {
        <div class="bg-white w-full rounded-lg border border-gray-200 p-4 mb-2">
            <app-question-view [q]="q" [isEditable]="true" (edit)="editQuestion($index, $event)"
                (delete)="deleteQuestion($event)"></app-question-view>
        </div>
        }
    </div>
</div>